export const APP_NAME = 'LoviBook';
export const APP_LOGO_URL = '/logo.webp?v=20260813';
export const APP_LOGO_PNG_URL = '/logo.png?v=20260422b';
export const PUBLIC_SITE_ORIGIN = 'https://www.lovibook.com';
